export const getAllListSubscription = () => `company/subscription/`;

export const getAllSchedules = () => `company/schedules/`;

export const getTypeSchedules = () => 'company/type-schedules/';

export const getBookStores = () => 'company/companies/';

export const getAllBookStores = () => 'company/companies/all-companies/';

export const getDeliveries = () => 'transport/province-limited-deliveries/'

export const getMenuCategory = () => 'utils/categories-menu/'

export const getHelpText = () => 'company/help-text/'

export const getLibraryComment = () => 'company/comment-library/'
